import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
} from '@mui/material'
import React, { useEffect, useState } from 'react'
import { useIntl } from 'react-intl'

export interface RenameConversationDialogProps {
  open: boolean
  conversationId?: string
  currentTitle?: string
  pending?: boolean
  onClose: () => void
  onSubmit: (id: string, title: string) => void
}

export default function RenameConversationDialog(props: RenameConversationDialogProps) {
  const intl = useIntl()
  const { open, conversationId, currentTitle, pending, onClose, onSubmit } = props
  const [title, setTitle] = useState(currentTitle ?? '')

  useEffect(() => {
    if (open) { setTitle(currentTitle ?? '') }
  }, [open, currentTitle])

  const canSave = title.trim().length > 0 && !pending
  const submit = () => {
    const t = title.trim()
    if (conversationId && t) { onSubmit(conversationId, t) }
  }

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth={true}>
      <DialogTitle>{intl.formatMessage({ id: 'caChat.renameDialog.title' })}</DialogTitle>
      <DialogContent>
        <TextField
          autoFocus={true}
          fullWidth={true}
          variant="standard"
          label={intl.formatMessage({ id: 'caChat.renameDialog.field.label' })}
          value={title}
          disabled={pending}
          onChange={(e) => setTitle(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === 'Enter' && canSave) { submit() }
          }}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={pending}>{intl.formatMessage({ id: 'caChat.renameDialog.button.cancel' })}</Button>
        <Button variant="contained" onClick={submit} disabled={!canSave}>{intl.formatMessage({ id: 'caChat.renameDialog.button.save' })}</Button>
      </DialogActions>
    </Dialog>
  )
}
